<template>
  <div class="menu-item-r potential-order">
    <div class="dash-content">
      <el-tabs v-model="activeName" @tab-click="handleTabClick" v-if="showTabBar()">
        <el-tab-pane :label="$t('order.all')" name="all"></el-tab-pane>
        <el-tab-pane :label="$t('order.me')" name="me"></el-tab-pane>
      </el-tabs>

      <section class="filter-container">
        <el-form :inline="true">
          <el-form-item>
            <el-input
              v-model="orderKeyword"
              size="mini"
              class="filter-keyword"
              :placeholder="subjectType === 'ACTOR' ? $t('Search by visitor name, exibits') : $t('Search by exibitor name, exibits')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('Order time')">
            <el-date-picker v-model="orderTime" value-format="yyyy-MM-dd" class="filter-orderTime" size="mini" type="date" clearable>
            </el-date-picker>
          </el-form-item>

          <el-form-item :label="$t('Contact status')">
            <el-select v-model="employeeStatus" size="mini" class="filter-employeeStatus" :placeholder="$t('please_select')" clearable>
              <el-option
                v-for="item in statusArray"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="subjectType === 'ACTOR' && activeName === 'all' && !noAdmin">
            <el-select v-model="employeeId" size="mini" class="filter-keyword-2" :placeholder="$t('Search employee')" clearable>
              <el-option
                v-for="item in employeeListInit"
                :key="item.id"
                :label="item.userInfoDTO.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="mini" @click="handleTabClick">{{ $t('homes.searchPlaceHolder') }}</el-button>
          </el-form-item>
        </el-form>
      </section>

      <section class="tips">
        {{ $t('Results are shown by Beijing Time (GMT+8)') }}
        <el-button class="export-btn" v-if="subjectType === 'ACTOR'" type="primary" size="mini" @click="exportDataTable"><i class="iconfont iconexport"></i>{{ $t('Export') }}</el-button>
      </section>
      <div v-loading="loading">
        <div class="order-table-header">
          <div class="order-header-cell cell-1" v-if="subjectType === 'ACTOR'">{{ $t('actor') }}</div>
          <div class="order-header-cell cell-2">{{ subjectType === 'ACTOR' ? $t('Potential Order') : $t('Wish Product') }}</div>
          <div class="order-header-cell cell-3">{{ subjectType === 'ACTOR' ? $t('Follow up person') : $t("Exhibitor's Salesman") }}</div>
          <div class="order-header-cell cell-4">
            {{ $t('Action') }}
          </div>
        </div>
        <div v-if="dataList.length === 0" class="no-data">{{ $t('common.noData') }}</div>
        <div v-for="item in dataList" :key="item.id">
          <div class="order-header">
            <!-- {{ formatDate(item.createTime) }} -->
            <span>{{ item.createTime  | formatDate('all') }} </span>
            <div v-if="item[subjectType === 'ACTOR'? 'employeeStatus': 'status']" class="tag completed">{{ $t('Order Completed') }}</div>
            <div v-else class="tag pending">{{ $t('Not completed yet') }}</div>
          </div>
          <div class="order-body">
            <div class="order-cell cell-1" v-if="subjectType === 'ACTOR'">
              <p>{{ item.userName }}</p>
              <p>{{ item.userCompany }}</p>
            </div>
            <div class="order-cell cell-2">
              <div class="product-cell-2">
                <img class="product-img" :src="item.productImg.split(',')[0]" @click="_pageDetail(item, 'product')" />
                <div class="product-content">
                  <div>
                    <span class="product-name" @click="_pageDetail(item, 'product')">{{ item.productName }}</span
                    ><br />
                    <span class="exhibitor-name" @click="pageDetail(item, 'actor')">{{ item.exhibitorName }}</span>
                  </div>
                  <div>
                    {{ $t('Potential Amount purchased', [`${item.num}`]) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="order-cell cell-3">
              <div class="assigned-employee" v-if="item.assigned">{{ item.employeeName }}</div>
              <div>
                <el-button v-if="subjectType === 'ACTOR' && !noAdmin" plain size="mini" @click="openAssignmentDialog(item.id)">{{
                  $t('Assign employee')
                }}</el-button>
                <span v-if="subjectType === 'VISITOR' && !item.assigned">{{ $t('Not assigned yet') }}</span>
              </div>
            </div>
            <div class="order-cell cell-4">
              <div>
                <el-select v-model="item[subjectType === 'ACTOR'? 'employeeStatus': 'status']" size="mini" :class="{'_en': language === 'en'}" 
                class="change-employeeStatus__cell" @change="setOrderStatus(item)">
                  <el-option
                    v-for="__item in statusArray"
                    :key="__item.id"
                    :label="__item.label"
                    :value="__item.value">
                  </el-option>
                </el-select>
                <el-divider direction="vertical"></el-divider>
                <el-popover placement="top-start" width="210" v-model="item.delPopVisible" v-if="subjectType === 'VISITOR'">
                  <div class="txt-deleting">
                    <i class="order-del el-icon-warning"></i> <span>{{ $t('Are you sure you want to delete this order?') }}</span>
                  </div>
                  <div style="text-align: right; margin: 10px 0 0 0">
                    <el-button size="mini" type="text" @click="item.delPopVisible = false">{{ $t('order.Cancel') }}</el-button>
                    <el-button type="primary" size="mini" @click="deleteOrder(item)">{{ $t('order.Confirm') }}</el-button>
                  </div>
                  <el-button type="text" slot="reference">{{ $t('Delete') }}</el-button>
                </el-popover>
                <template v-if="item.assigned">
                  <el-divider direction="vertical" v-if="subjectType === 'VISITOR'"></el-divider>
                  <el-button type="text" @click="chat(item)">{{ $t('Chat') }}</el-button>
                </template>
                <el-divider direction="vertical"></el-divider>
                <el-button type="text" @click="openDetailDialog(item.id)">{{ $t('details') }}</el-button>
                <!-- <template v-if="subjectType === 'VISITOR' && !item.status">
                  <el-divider direction="vertical"></el-divider>
                  <el-button type="text" @click="complateOrder(item.id)">{{ $t('Complete order') }}</el-button>
                </template> -->
              </div>
            </div>
          </div>
        </div>

        <div class="bl-container">
          <el-pagination
            v-if="dataList.length > 0"
            background
            @current-change="handlePageChange"
            :page-size="pagination.pageRows"
            :current-page.sync="pagination.pageNum"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
            class="bl-page"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 分配业务员 弹窗 -->
      <winDialog
        :dialogShow.sync="showAssignmentDialog"
        :title="$t('Assign salesman')"
        :subTitle="$t('You can chat with potential customer by assigning salesman, managing your potential order')"
        :sure="assignSalesman"
        :cancel="resetEmployeeKeyword"
      >
        <template v-slot:bodyContent>
          <el-form :inline="true" class="employee-search-form">
            <el-form-item>
              <el-input
                v-model="employeeKeyword"
                size="mini"
                class="input__employee-name"
                :placeholder="$t('Enter salesman name for searching')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="openAssignmentDialog">{{ $t('homes.searchPlaceHolder') }}</el-button>
            </el-form-item>
          </el-form>
          <div class="employee-table-wraper">
            <el-table
              :data="employeeList"
              ref="employeeTable"
              stripe
              @current-change="handleCurrentChange"
              :header-cell-style="{ background: '#FAFAFA' }"
              class="employee-table"
            >
              <el-table-column width="35">
                <template slot-scope="scope">
                  <el-radio v-model="assignedEmployeeId" :label="scope.row.id" class="label__employeeId"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="userInfoDTO.name" :label="$t('name')" width="180"> </el-table-column>
              <el-table-column prop="userInfoDTO.mobile" :label="$t('phone')" width="180"> </el-table-column>
              <el-table-column prop="userInfoDTO.email" :label="$t('email')"> </el-table-column>
            </el-table>
          </div>
          <div class="current-employee">
            <span class="_select">{{ $t('You selected') }}</span>
            <el-divider direction="vertical"></el-divider>
            <template v-if="currentEmployee.name">
              <span class="_name">{{ currentEmployee.name }} </span>
              <span class="_tel">{{ currentEmployee.mobile || currentEmployee.email }} </span>
            </template>
          </div>
        </template>
      </winDialog>

      <!-- 查看详情 弹窗 -->
      <winDialog
        :dialogShow.sync="showDetailDialog"
        :showFooter="false"
        :title="$t('Potential order detail')"
        :subTitle="$t('Record the data and status for the current order detail')"
      >
        <template v-slot:bodyContent>
          <div class="flex">
            <div>
              <el-divider direction="vertical" class="divider-red"></el-divider>
              <!-- {{ formatDate(orderDetail.createTime) }} -->
              <span class="detail_date">{{ orderDetail.createTime  | formatDate('all') }}</span>

              <div class="tag completed" v-if="subjectType === 'VISITOR' && orderDetail.status">{{ $t('Order Completed') }}</div>
              <div class="tag pending" v-if="subjectType === 'VISITOR' && !orderDetail.status">{{ $t('Not completed yet') }}</div>

              <div class="tag completed" v-if="subjectType === 'ACTOR' && orderDetail.employeeStatus">{{ $t('Order Completed') }}</div>
              <div class="tag pending" v-if="subjectType === 'ACTOR' && !orderDetail.employeeStatus">{{ $t('Not completed yet') }}</div>
<!-- 
              <div class="tag completed" v-if="subjectType === 'ACTOR' && orderDetail.assigned">{{ $t('Salesman already assigned') }}</div>
              <div class="tag pending" v-if="subjectType === 'ACTOR' && !orderDetail.assigned">{{ $t('Salesman not assigned') }}</div> -->
            </div>

            <!-- <el-button v-if="subjectType === 'VISITOR' && !orderDetail.status" type="primary" size="mini" @click="complateOrder(orderDetail.id)">{{
              $t('Complete order')
            }}</el-button> -->

            <el-select v-model="orderDetail[subjectType === 'ACTOR'? 'employeeStatus': 'status']" size="mini" :class="{'_en': language === 'en'}" class="change-employeeStatus" @change="setOrderStatus(orderDetail)">
              <el-option
                v-for="item in statusArray"
                :key="item.id"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <!-- <div v-if="subjectType === 'ACTOR' && orderDetail.assigned">{{ $t('Follow up person') }}: {{ orderDetail.employeeName }}</div>
            <el-button
              v-if="subjectType === 'ACTOR' && !orderDetail.assigned"
              type="primary"
              size="mini"
              @click="openAssignmentDialog(orderDetail.id)"
              >{{ $t('Assign employee') }}</el-button
            > -->
          </div>

          <div v-if="subjectType === 'VISITOR'" class="exhibitor-detail">
            <div class="product-content">
              <div class="color-gray">{{ $t('Wish Exhibitor') }}</div>
              <div>
                {{ orderDetail.exhibitorName }}
              </div>
            </div>
            <div class="amount-purchased">
              <div class="amount-title">{{ $t('Order Employee') }}</div>
              <div class="amount">{{ orderDetail.employeeName }}</div>
            </div>
          </div>

          <div v-if="subjectType === 'ACTOR'" class="current-employee detail-section">
            <span class="_select_detail">{{ $t('actor') }}</span>
            <el-divider direction="vertical"></el-divider>
            <span class="_name_detail">{{ orderDetail.userName }} </span>
            <span class="_tel_detail">{{ orderDetail.userCompany }} </span>
          </div>

          <div class="section-title-container">
            <el-divider direction="vertical" class="divider-red"></el-divider>
            <span class="section-title">{{ $t('Potential Order') }}</span>
          </div>

          <div class="order-detail">
            <div class="product-cell-2">
              <img class="product-img" :src="orderDetail.productImg.split(',')[0]" />
              <div class="product-content">
                <div>{{ orderDetail.productName }}</div>
                <div class="color-gray">
                  {{ orderDetail.exhibitorName }}
                </div>
              </div>
              <div class="amount-purchased">
                <div class="amount-title">{{ $t('Amount purchased') }}</div>
                <div class="amount">{{ orderDetail.num }}</div>
              </div>
            </div>
          </div>

          <div class="section-title-container">
            <el-divider direction="vertical" class="divider-red"></el-divider>
            <span class="section-title">{{ $t('order.remarks') }}</span>
          </div>
          <div class="section-content">
            {{ orderDetail.remark }}
          </div>
        </template>
      </winDialog>
    </div>
  </div>
</template>
<script>
import fileDownload from 'js-file-download'
import { mapGetters } from 'vuex'
import { getOwnOrder, getOrderPage, getOrderDetail, getEmployeeList, assignEmployee, delOrder, changeOrderStatus, exportOrder } from '@/api/potentialOrder'
import winDialog from '@/components/dialog/dialog'
const pageRows = 4

export default {
  components: {
    winDialog
  },

  computed: {
    ...mapGetters(['info', 'subjectType', 'language']),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    }
  },
  data() {
    return {
      activeName: this.subjectType === 'ACTOR'? 'all': 'me',
      orderKeyword: '',
      employeeKeyword: '',
      orderTime: '',
      employeeStatus: '',
      employeeId: '',
      loading: false,
      quantity: {
        totalNum: 0,
        notAssignedNum: 0,
        assignedNum: 0
      },
      dataList: [],
      pagination: {
        pageNum: this.pageNum,
        pageRows: pageRows,
        total: 0
      },

      showAssignmentDialog: false,
      currentEmployee: {
        name: '',
        mobile: ''
      },
      assignedEmployeeId: '',
      employeeList: [],
      employeeListInit: [],
      currentOrderId: '',
      orderDetail: {
        productImg: ''
      },
      showDetailDialog: false,
      pageNum: 1, // current page,
      statusArray: [{
        id: 1,
        value: true,
        label: this.$t('Order Completed')
      }, {
        id: 2,
        value: false,
        label: this.$t('Not completed yet')
      }]
    }
  },

  mounted() {
    // if (this.$route.params.source === undefined && this.subjectType !== 'ACTOR') {
    //   this.$router.push('/potential-order/me')
    //   return false
    // }
    if(this.subjectType === 'ACTOR') {
      this.activeName = 'all'
    }
    this.getList()
    if(this.subjectType === 'ACTOR') {
      getEmployeeList({
        userName: ''
      }).then(res => {
        this.employeeListInit = res.data.data
      })
    }
  },

  methods: {

    _pageDetail(item) {
      if(this.subjectType === 'ACTOR') {
        this.pageDetail(item, 'self_product')
      }

      if(this.subjectType === 'VISITOR') {
        this.pageDetail(item, 'product')
      }
      
    },

    showTabBar() {
      if (this.subjectType === 'ACTOR' && !this.noAdmin) {
        // if (this.$route.params.source === undefined) {
          return true
        // }
      }
      return false
    },

    // formatDate(date) {
    //   return this.$funcs.dateFormat(date, 'YYYY-mm-dd HH:MM:SS')
    // },

    handleTabClick() {
      this.pageNum = 1
      this.getList()
    },

    getList() {
      this.loading = true
      if ( this.activeName === 'me') {
        let params = {
          pageNum: this.pageNum,
          pageRows: pageRows,
          searchStr: this.orderKeyword,
          searchTime: this.orderTime
        }
        if( this.subjectType === 'ACTOR' && this.employeeStatus !== '') {
          params.employeeStatus = this.employeeStatus
        }
        if( this.subjectType === 'VISITOR' && this.employeeStatus !== '') {
          params.status = this.employeeStatus
        }
        getOwnOrder(params).then(res => {
          this.dataList = res.data.data.list
          this.pagination.total = res.data.data.total
          this.loading = false
        })
      }

      if (this.activeName === 'all') {
        let params = {
          pageNum: this.pageNum,
          pageRows: pageRows,
          searchStr: this.orderKeyword,
          searchTime: this.orderTime,
          employeeId: this.employeeId
        }
        if (this.activeName === 'notAssigned') {
          params.assigned = false
        }

        if (this.activeName === 'assigned') {
          params.assigned = true
        }

        if( this.subjectType === 'ACTOR' && this.employeeStatus !== '') {
          params.employeeStatus = this.employeeStatus
        }
        if( this.subjectType === 'VISITOR' && this.employeeStatus !== '') {
          params.status = this.employeeStatus
        }
        getOrderPage(params).then(res => {
          this.dataList = res.data.data.page.list
          this.pagination.total = res.data.data.page.total
          this.loading = false
          if (this.activeName === 'all') {
            this.quantity = res.data.data.num
          }
        })
      }
    },

    handlePageChange(val) {
      this.pageNum = val
      this.getList()
    },

    handleCurrentChange(val) {
      if (val) {
        this.currentEmployee = val.userInfoDTO
        this.assignedEmployeeId = val.id
      }
    },

    resetEmployeeKeyword(cb) {
      this.employeeKeyword = ''
      cb()
    },

    openAssignmentDialog(currentOrderId) {
      this.currentOrderId = currentOrderId || ''
      this.assignedEmployeeId = ''
      this.currentEmployee = {
        name: '',
        mobile: ''
      }
      const loading = this.$loading({
        lock: true
      })
      getEmployeeList({
        userName: this.employeeKeyword
      }).then(res => {
        this.employeeList = res.data.data
        this.showAssignmentDialog = true
        loading.close()
      })
    },

    openDetailDialog(id) {
      const loading = this.$loading({
        lock: true
      })
      getOrderDetail({
        id
      }).then(res => {
        this.orderDetail = res.data.data
        this.showDetailDialog = true
        loading.close()
      })
    },

    assignSalesman(cb) {
      if (!this.assignedEmployeeId) {
        this.$notify.warning(this.$t('Please select a salesman'))
        return
      }
      if (this.currentOrderId) {
        assignEmployee({
          id: this.currentOrderId,
          employeeId: this.assignedEmployeeId
        }).then(() => {
          this.getList()
          this.showDetailDialog = false
          cb()
        })
      }
    },

    setOrderStatus(detail) {
      const loading = this.$loading({
        lock: true
      })
      changeOrderStatus({
        id: detail.id,
        status: detail[this.subjectType === 'ACTOR'? 'employeeStatus': 'status']? 1: 0
      }).then(() => {
        this.getList()
        // this.showDetailDialog = false
        loading.close()
      }).finally(()=> {
        loading.close()
        this.getList()
      })
    },

    deleteOrder(item) {
      const loading = this.$loading({
        lock: true
      })
      delOrder({ id: item.id }).then(() => {
        this.getList()
        item.delPopVisible = false
        loading.close()
        this.$notify({
          title: this.$t('tip.success'),
          message: this.$t('Delete potential order successfully'),
          type: 'success'
        })
      })
    },

    async chat(item) {
      if (item.userAccountId) {
        console.log('this.$store.getters.isSDKReady--->', this.$store.getters.isSDKReady)

        let receiver = {}
        if (this.subjectType === 'VISITOR') {
          receiver = {
            easemobAccount: item.employeeEasemobAccount,
            avatar: item.employeePhoto,
            position: this.$t("Exhibitor's Salesman"),
            name: item.employeeName,
            id: item.employeeId,
            exhibitorId: item.exhibitorId,
            
          }
        }

        if (this.subjectType === 'ACTOR') {
          receiver = {
            easemobAccount: item.userEasemobAccount,
            avatar: item.userPhoto,
            position: item.userPosition,
            name: item.userName,
            id: item.userId
          }
        }

      
        await this.getUserConversationList(item.userAccountId)
      }
    },
    async getUserConversationList(userID) {
      console.log(this.$TIM_EVENT.SDK_READY)
    },

    exportDataTable() {
      let params = {
        exportAll: this.activeName !== 'me',
        searchStr: this.orderKeyword,
        searchTime: this.orderTime,
        isStream : true
      }

      if (this.activeName === 'notAssigned') {
        params.assigned = false
      }

      if (this.activeName === 'assigned') {
        params.assigned = true
      }

      exportOrder(params).then(res => {
        fileDownload( res.data, `order_${new Date().getTime()}.xls`)
      })
    }
  }
}
</script>

<style lang="stylus">

.txt-deleting
  display flex
  span
    display block
    padding-left 8px
    word-break break-word
    line-height 1.5
.order-del.el-icon-warning
  color #FAAD14
  line-height 1.6
.dash-content
  padding 15px
  background #fff
  margin 30px auto
  max-width 100%
  .change-employeeStatus__cell
    color $color-main
    width 68px
    &._en
      width 142px
    input
      border none
      background #fbfbfb
      padding 0
      color $color-main
      font-size 14px
      text-align right
      padding-right 25px
    .el-input__suffix
      right -5px
      .el-select__caret
        color $color-main
  .change-employeeStatus
    width 90px
    border-radius 4px
    &._en
      width 150px
    input
      background $color-main
      color $color-white
      border none
  .product-cell-2
    display flex
    align-items center
    justify-content flex-start
    height 100%
  .product-img
    width 100px
    height 100px
    margin-right 12px
    cursor pointer
    object-fit cover
  .product-content
    display flex
    width 242px
    flex-direction column
    justify-content space-between
    line-height 1.5
    height 100%
    text-align left
    .product-name,
    .exhibitor-name
      cursor pointer
  .el-tabs__item
    color $color-black-45
  .el-tabs__item.is-active
    color $color-main
  .filter-container
    padding 10px 0 25px 0
  .filter-keyword
    width 238px
    margin-right 15px
  .filter-keyword-2
    width 200px
    margin-right 15px
  .filter-orderTime
    width 150px
    margin-right 15px
  .filter-employeeStatus
    width 200px
    margin-right 15px
  .tips
    font-size 12px
    color $color-black-45
    line-height 32px;
    margin-bottom 15px
  .order-header
    padding 0 24px
    background $color-gray-f1
    height 32px
    width 100%
    display flex
    align-items center
    font-size 12px
  .tag
    min-width 52px
    height 17px
    border-radius 2px
    text-align center
    font-size 12px
    color $color-white
    display inline-block
    line-height 1.5
    margin-left 10px
    padding 0 10px
  .tag.completed
    background $color-blue-48
  .tag.pending
    background $color-red-78
  .cell-1
    width 265px
  .cell-2
    flex 1 auto
    padding 24px
    width 410px
  .cell-3
    width 160px
  .cell-4
    width 283px
  .no-data
    text-align center
    line-height 3
    font-size 14px
    background $color-gray-f1

  .order-table-header
    display flex
    background #FAFAFA
    color: #000000
    font-weight bold
    font-size 14px
    height 54px
    margin-top 10px
    width 100%
    .order-header-cell
      display flex
      flex-direction column
      justify-content center
      text-align center
      font-size 14px
      height 100%
      color $color-black-65
  .order-body
    border 1px solid $color-gray-217
    border-top none
    min-height 150px
    display flex
    margin-bottom 16px
    .assigned-employee
      margin-bottom 8px
    .order-cell
      border-right 1px solid $color-gray-217
      display flex
      flex-direction column
      justify-content center
      text-align center
      font-size 14px
      min-height 100%
      color $color-black-65
      &.cell-1
        line-height 1.5
      &:last-child
        border-right none
  .input__employee-name
    width 255px
  .employee-search-form
    margin 0 auto
    padding-left 40px
  .employee-table-wraper
    max-height 370px
    overflow-y scroll
  .employee-table

    margin 0 auto
    .label__employeeId .el-radio__label
      display none
    .el-table__row > td,
    &.el-table th
      border none
    &.el-table:before
      height 0px
  .current-employee
    height 54px
    margin 24px auto 0
    padding-left 40px
    background $color-white
    display flex
    align-items center
    &.detail-section
      padding-left 16px
    ._select
      color $color-gray-fc1
      font-size 14px
    ._select_detail
      color $color-gray-45
      font-size 14px
    ._name
      font-size 20px
      color $color-gray-fc1
      font-weight bold
    ._name_detail
      font-size 16px
      color $color-gray-65
      font-weight 400
    ._tel
      font-size 14px
      color $color-gray-fc2
      margin-left 10px
    ._tel_detail
      font-size 16px
      color $color-gray-65
      margin-left 10px
      font-weight 400
  .section-title-container
    margin-top 24px
  .product-content
    width 365px
    padding-right 20px
  .color-gray
    color $color-gray-45
  .amount-purchased
    border-left 1px solid $color-gray-09
    display flex
    flex-direction column
    justify-content space-around
    text-align center
    flex 1 0 auto
    height 100%
    .amount-title
      color $color-gray-45
    .amount
      color $color-black-85
      font-weight 500
      font-size 18px
  .exhibitor-detail
    margin-top 24px
    padding 16px
    background $color-white-01
    height 86px
    display flex
    align-items center
    justify-content flex-start
    .product-content
      width 478px
    .amount
      font-size 14px
  .order-detail
    padding 16px
    background $color-white-01
    height 132px

  .section-title
    font-size 14px
  .section-content
    padding 16px
  .detail_date
    color $color-gray-85
    font-weight 500
    font-size 12px
  .divider-red
    width 2px
    background-color $color-main
  .export-btn
    float right
    .iconfont
      margin-left 0
</style>
